// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bmOS","tabsBox":"styles_tabsBox__35bPE","createButton":"styles_createButton__kIJpj"};